export class DialogHarnessController {
  constructor() {}
}
